globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { createContext, useContext, useMemo } from 'react'; //--> Interfaces and types

import { jsx as _jsx } from "react/jsx-runtime";
//--> Context
var NavigationContext = /*#__PURE__*/createContext(null); //--> Provider

var NavigationContextProvider = function NavigationContextProvider(_ref) {
  var children = _ref.children,
      inputLinkComponent = _ref.linkComponent,
      inputRouter = _ref.router;
  return /*#__PURE__*/_jsx(NavigationContext.Provider, {
    value: {
      linkComponent: inputLinkComponent,
      router: inputRouter
    },
    children: children
  });
}; //--> Hook


var useNavigationContext = function useNavigationContext() {
  var context = useContext(NavigationContext);
  if (!context) throw new Error('useNavigationContext must be used within a NavigationContext');
  return useMemo(function () {
    return context;
  }, [context]);
};

export { NavigationContextProvider, useNavigationContext };